// Toggle de tema claro/oscuro como icono (sol/luna) anclado a una esquina.
//
// Se monta una sola vez a nivel de PartnerShell (dentro del ThemeProvider) →
// aparece en TODAS las pantallas sin ocupar lugar en el layout (position:
// fixed). Reemplaza el boton de texto que antes vivia en el footer de
// AuthShell y engordaba la barra inferior.
//
// A11y: icono decorativo (aria-hidden); el boton lleva aria-label descriptivo
// + aria-pressed para comunicar estado a screen readers. Touch target 44x44.

import { useTheme } from '@/theme/ThemeProvider';

export default function ThemeToggle(): JSX.Element {
  const { colorScheme, toggleColorScheme } = useTheme();
  const isDark = colorScheme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleColorScheme}
      aria-label={`Cambiar a tema ${isDark ? 'claro' : 'oscuro'}`}
      aria-pressed={isDark}
      title={`Tema ${isDark ? 'claro' : 'oscuro'}`}
      className="fixed top-3 right-3 z-50 grid h-11 w-11 place-items-center rounded-full text-text-muted transition hover:bg-surface hover:text-text focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
    >
      {isDark ? (
        // Modo oscuro activo → ofrecemos pasar a claro: mostramos un sol.
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
        </svg>
      ) : (
        // Modo claro activo → ofrecemos pasar a oscuro: mostramos una luna.
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
}
